import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../environments/environment';
import { ProfiloModel } from '../core/models/api/profilo.model';

@Injectable({
  providedIn: 'root',
})
export class ProfiliService {
  apiUrl: string = environment.backend.baseUrl + '/profili';

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
  ) {}

  getProfili(): Observable<ProfiloModel[]> {
    return this.http.get<ProfiloModel[]>(this.apiUrl).pipe(
      tap(profili => this.logger.debug('[PROFILI-SERVICE] Profili caricati:', profili.length)),
      catchError(error => {
        this.logger.error('[PROFILI-SERVICE] Errore nel caricamento dei profili:', error);
        // L'errore deve arrivare al chiamante: vedi nota in RequisitiService.getClienti().
        return throwError(() => error);
      })
    );
  }

  createProfilo(payload: {
    nome: string;
    cognome: string;
  }): Observable<ProfiloModel> {
    return this.http.post<ProfiloModel>(this.apiUrl, payload).pipe(
      tap((profilo) =>
        this.logger.debug(
          '[PROFILI-SERVICE] Profilo creato:',
          `${profilo.nome} ${profilo.cognome}`.trim(),
        ),
      ),
    );
  }
}
